import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { CancelMembershipFormValues } from "./types";

export const INITIAL_VALUES_CANCEL_MEMBERSHIP_FORM: CancelMembershipFormValues =
  {
    date: undefined,
  };

export const cancelMembershipFormSchema = toFormikValidationSchema(
  z.object({
    date: z
      .object(
        {
          id: z.union([z.string(), z.number()]),
          label: z.string(),
          value: z.custom<string>(),
        },
        { required_error: "Cancellation Date is required" },
      )
      .nullable(),
  }),
);
